import React, { useId } from 'react';

import classes from './HeartEkgIcon.module.css';

/**
 * Red heart with an ECG blip running through it.
 * When bpm is set, animation pace tracks the live rate.
 */
export default function HeartEkgIcon({
  size = 28,
  className,
  bpm = null,
  active = true,
}) {
  const clipId = useId().replace(/:/g, '');
  const safeBpm =
    active && bpm != null && Number.isFinite(bpm)
      ? Math.min(180, Math.max(40, Math.round(bpm)))
      : null;
  // Visual pace is intentionally slower than real BPM so the blip reads clearly.
  const durationSec = safeBpm ? (60 / safeBpm) * 2.4 : 2.3;

  return (
    <svg
      className={[classes.root, className].filter(Boolean).join(' ')}
      width={size}
      height={size}
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
      style={{ '--ekg-duration': `${durationSec}s` }}
    >
      <defs>
        <clipPath id={clipId}>
          <path d="M24 42.5C24 42.5 6.5 31.2 4.2 21.4 2.2 13.2 8.1 8 14.6 8c3.9 0 6.9 2.1 9.4 5.3C26.5 10.1 29.5 8 33.4 8c6.5 0 12.4 5.2 10.4 13.4C41.5 31.2 24 42.5 24 42.5Z" />
        </clipPath>
      </defs>

      <path
        className={classes.heart}
        d="M24 42.5C24 42.5 6.5 31.2 4.2 21.4 2.2 13.2 8.1 8 14.6 8c3.9 0 6.9 2.1 9.4 5.3C26.5 10.1 29.5 8 33.4 8c6.5 0 12.4 5.2 10.4 13.4C41.5 31.2 24 42.5 24 42.5Z"
      />

      <g clipPath={`url(#${clipId})`}>
        <path
          className={[classes.ekg, active ? classes.ekgActive : '']
            .filter(Boolean)
            .join(' ')}
          d="M-8 26 H10 L14 18 L19 34 L24 14 L28 26 H56"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
